import Joi from "joi-browser";

export function getCOPSDv2Schema() {
  return {
    SelectedProgram: Joi.string()
      .allow("")
      .required()
      .label("Selected Program"),
    SexAssignedAtBirth: Joi.string().label("Sex Assigned at Birth").required(),
    SexAssignedAtBirthDetails: Joi.string()
      .label("Sex Assigned at Birth Specifics")
      .when("SexAssignedAtBirth", {
        is: "Sex not listed",
        then: Joi.required(),
      }),
    Pronouns: Joi.string().label("Pronouns").required(),
    PronounsDescription: Joi.string()
      .label("Pronouns description")
      .when("Pronouns", {
        is: "Prefer to self-describe",
        then: Joi.required(),
      }),
    GenderIdentity: Joi.string().label("Gender Identity").required(),
    GenderIdentityDescription: Joi.string()
      .label("Gender Identity description")
      .when("GenderIdentity", {
        is: "Identity not listed",
        then: Joi.required(),
      }),
    DateCompleted: Joi.string().label("Date Completed").required(),
    PSDType: Joi.string().label("Type of PSD").required(),
    ReviewReason: Joi.string()
      .label("Review Reason")
      .when("PSDType", { is: "Review/Update", then: Joi.required() }),
    ISClient: Joi.boolean(),
    ISParent: Joi.boolean(),
    ISGuardian: Joi.boolean(),
    ISCaregiver: Joi.boolean(),
    ISPhysician: Joi.boolean(),
    ISRecords: Joi.boolean(),
    ISServiceProvider: Joi.boolean(),
    ISSchool: Joi.boolean(),
    ISCourt: Joi.boolean(),
    ISCPS: Joi.boolean(),
    ISOther: Joi.boolean(),
    ISOtherDetails: Joi.string()
      .label("Other Information Source")
      .when("ISOther", { is: true, then: Joi.required() }),
    ReferralReason: Joi.string().label("Reason for Referral").required(),
    ReferralSource: Joi.string().label("Referral Source").required(),
    PresentingProblem: Joi.string().label("Presenting Problem").required(),
    ClientProblem: Joi.string()
      .label("Client Description of Problem")
      .required(),
    CaregiverProblem: Joi.string()
      .label("Caregiver Description of Problem")
      .required(),
    ClientStrengths: Joi.string()
      .label("Client Description of Strengths")
      .required(),
    CaregiverStrengths: Joi.string()
      .label("Caregiver Description of Strengths")
      .required(),
    ClientAbilities: Joi.string()
      .label("Client abilities, skills, and interests")
      .required(),
    Barriers: Joi.string().label("Barriers").required(),
    PrimaryHouseholdType: Joi.string()
      .label("Primary Household Type")
      .required(),
    PrimaryHouseholdDetails: Joi.string()
      .label("Primary Household Details")
      .required(),
    PrimaryHouseholdDisciplinePracticesNA: Joi.boolean(),
    PrimaryHouseholdCaregiverCooperation: Joi.string()
      .label("Cooperation")
      .when("PrimaryHouseholdDisciplinePracticesNA", {
        is: false,
        then: Joi.required(),
      }),
    PrimaryHouseholdSupervisionDifficulties: Joi.string()
      .label("Supervision difficulties")
      .when("PrimaryHouseholdDisciplinePracticesNA", {
        is: false,
        then: Joi.required(),
      }),
    PrimaryHouseholdDisciplinePracticesDetails: Joi.string()
      .label("Discipline practices details")
      .when("PrimaryHouseholdDisciplinePracticesNA", {
        is: false,
        then: Joi.required(),
      }),
    SecondaryHousehold: Joi.string()
      .label("Is there a secondary household?")
      .required(),
    SecondaryHouseholdType: Joi.string()
      .label("Secondary Household Type")
      .when("SecondaryHousehold", { is: "Yes", then: Joi.required() }),
    SecondaryHouseholdDetails: Joi.string()
      .label("Secondary Household Details")
      .when("SecondaryHousehold", { is: "Yes", then: Joi.required() }),
    SecondaryHouseholdDisciplinePracticesNA: Joi.boolean(),
    SecondaryHouseholdCaregiverCooperation: Joi.string().allow(""),
    SecondaryHouseholdSupervisionDifficulties: Joi.string().allow(""),
    SecondaryHouseholdDisciplinePracticesDetails: Joi.string().allow(""),
    AnySupportivePeople: Joi.string()
      .label("Are there any supportive people")
      .required(),
    SupportivePeopleDetails: Joi.string()
      .label("Supportive people details")
      .when("AnySupportivePeople", { is: "Yes", then: Joi.required() }),
    FamilyHistoryUnknown: Joi.boolean(),
    FamilyHistoryDetails: Joi.string()
      .label("Family History")
      .when("FamilyHistoryUnknown", { is: false, then: Joi.required() }),
    RemovedFromBioHome: Joi.string()
      .label("Has youth been removed from biological home")
      .required(),
    RemovedFromBioHomeFeelings: Joi.string()
      .label("Youth's feelings on being removed")
      .when("RemovedFromBioHome", { is: "Yes", then: Joi.required() }),
    CulturalGroup: Joi.string().label("Identified cultural group").required(),
    Traditions: Joi.string()
      .label("Special cultural traditions/celebrations/rituals")
      .required(),
    TraditionsComments: Joi.string()
      .label(
        "Comments regarding special cultural traditions/celebrations/rituals"
      )
      .when("Traditions", { is: "Yes", then: Joi.required() }),
    LanguagesSpoken: Joi.string().label("Languages spoken").required(),
    FamilyValues: Joi.string().label("Family values").required(),
    NegativeCulturalExperience: Joi.string()
      .label("Negative experiences due to customs/ethnicity/race/SES")
      .required(),
    NegativeCulturalExperienceComments: Joi.string()
      .label("Negative experience comments")
      .when("NegativeCulturalExperience", { is: "Yes", then: Joi.required() }),
    InFosterCare: Joi.string().label("Youth in foster care?").required(),
    PlacesLived: Joi.string()
      .label("Places lived")
      .when("InFosterCare", { is: "Yes", then: Joi.required() }),
    CulturalDifferences: Joi.string()
      .label("Cultural differences")
      .when("InFosterCare", { is: "Yes", then: Joi.required() }),
    CulturalDifferencesComments: Joi.string()
      .label("Cultural differences comments")
      .when("CulturalDifferences", { is: "Yes", then: Joi.required() }),
    Religious: Joi.string()
      .label("Religious or spiritual belief system")
      .required(),
    ReligiousComments: Joi.string()
      .label("Religious or spiritual belief system comments")
      .when("Religious", { is: "Yes", then: Joi.required() }),
    PHNoProblems: Joi.boolean(),
    PHPrenatalCare: Joi.string()
      .label("Prenatal Care")
      .when("PHNoProblems", { is: false, then: Joi.required() }),
    PHPrenatalCareComments: Joi.string()
      .label("Prenatal Care comments")
      .when("PHPrenatalCare", { is: "No", then: Joi.required() }),
    PHExposure: Joi.string()
      .label("Exposure to alcohol, tobacco, and other drugs")
      .when("PHNoProblems", { is: false, then: Joi.required() }),
    PHExposureComments: Joi.string()
      .label(
        "Comments related to mother's exposure to alcohol, tobacco, and other drugs"
      )
      .when("PHExposure", { is: "Yes", then: Joi.required() }),
    PHTrauma: Joi.string()
      .label("History of significant trauma during pregnancy")
      .when("PHNoProblems", { is: false, then: Joi.required() }),
    PHTraumaComments: Joi.string()
      .label("History of significant trauma during pregnancy comments")
      .when("PHTrauma", { is: "Yes", then: Joi.required() }),
    PHComplications: Joi.string()
      .label("Birth complications")
      .when("PHNoProblems", { is: false, then: Joi.required() }),
    PHComplicationsComments: Joi.string()
      .label("Birth complications comments")
      .when("PHComplications", { is: "Yes", then: Joi.required() }),
    PHConcerns: Joi.string()
      .label("Medical concerns")
      .when("PHNoProblems", { is: false, then: Joi.required() }),
    PHConcernsComments: Joi.string()
      .label("Medical concerns comments")
      .when("PHConcerns", { is: "Yes", then: Joi.required() }),
    DevelopmentalDelays: Joi.string().label("Developmental delays").required(),
    DevelopmentalDelaysDetails: Joi.string()
      .label("Developmental Delays details")
      .when("DevelopmentalDelays", { is: "Yes", then: Joi.required() }),
    SpecializedServices: Joi.string().label("Specialized Services").required(),
    SpecializedServicesDetails: Joi.string()
      .label("Specialized Services details")
      .when("SpecializedServices", { is: "Yes", then: Joi.required() }),
    EducationStatus: Joi.string().label("Education status").required(),
    SchoolName: Joi.string().label("School Name").when("EducationStatus", {
      is: "Currently Enrolled in School/Client is School Aged",
      then: Joi.required(),
    }),
    CurrentGrade: Joi.string().label("Current Grade").when("EducationStatus", {
      is: "Currently Enrolled in School/Client is School Aged",
      then: Joi.required(),
    }),
    RegularClassroom: Joi.string()
      .label("Regular Classroom")
      .when("EducationStatus", {
        is: "Currently Enrolled in School/Client is School Aged",
        then: Joi.required(),
      }),
    Active504Plan: Joi.string()
      .label("Active 504 Plan")
      .when("EducationStatus", {
        is: "Currently Enrolled in School/Client is School Aged",
        then: Joi.required(),
      }),
    ActiveIEP: Joi.string().label("Active IEP").when("EducationStatus", {
      is: "Currently Enrolled in School/Client is School Aged",
      then: Joi.required(),
    }),
    DisciplineConcerns: Joi.string()
      .label("Discipline Concerns")
      .when("EducationStatus", {
        is: "Currently Enrolled in School/Client is School Aged",
        then: Joi.required(),
      }),
    DisciplineConcernsDetails: Joi.string()
      .label("Discipline concerns details")
      .when("DisciplineConcerns", { is: "Yes", then: Joi.required() }),
    Awards: Joi.string().label("Awards").when("EducationStatus", {
      is: "Currently Enrolled in School/Client is School Aged",
      then: Joi.required(),
    }),
    AwardsDetails: Joi.string()
      .label("Awards details")
      .when("Awards", { is: "Yes", then: Joi.required() }),
    SchoolAttitude: Joi.string()
      .label("Attitude toward school")
      .when("EducationStatus", {
        is: "Currently Enrolled in School/Client is School Aged",
        then: Joi.required(),
      }),
    CurrentlyEmployed: Joi.string().label("Currently employed").required(),
    ADLNA: Joi.boolean(),
    MoneyManagement: Joi.string()
      .label("Money management")
      .when("ADLNA", { is: false, then: Joi.required() }),
    FoodManagement: Joi.string()
      .label("Food management")
      .when("ADLNA", { is: false, then: Joi.required() }),
    Hygiene: Joi.string()
      .label("Personal appearance and hygiene")
      .when("ADLNA", { is: false, then: Joi.required() }),
    Health: Joi.string()
      .label("Health awareness/Personal Health")
      .when("ADLNA", { is: false, then: Joi.required() }),
    Housekeeping: Joi.string()
      .label("Housekeeping")
      .when("ADLNA", { is: false, then: Joi.required() }),
    ResourceKnowledge: Joi.string()
      .label("Knowledge of community resources")
      .when("ADLNA", { is: false, then: Joi.required() }),
    TimeManagement: Joi.string()
      .label("Time Management")
      .when("ADLNA", { is: false, then: Joi.required() }),
    Interaction: Joi.string()
      .label("Interactions with Others")
      .when("ADLNA", { is: false, then: Joi.required() }),
    SkillsComments: Joi.string()
      .label("Skill comments")
      .when("ADLNA", { is: false, then: Joi.required() }),
    RelationshipsNA: Joi.boolean(),
    CoopSkills: Joi.string()
      .label("Cooperative play skills")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    CommunicationSkills: Joi.string()
      .label("Communication and interaction skills")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    EmotionalUnderstanding: Joi.string()
      .label("Emotional understanding and self-regulation skills")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    ProblemSolving: Joi.string()
      .label("Social problem-solving skills")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    ConflictResolution: Joi.string()
      .label("Conflict resolution skills")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    DecisionMakingSkills: Joi.string()
      .label("Decision making skills")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    RelationshipSkillsComments: Joi.string()
      .label("Relationship skills comments")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    Bullied: Joi.string()
      .label("History of being bullied")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    BulliedDetails: Joi.string()
      .label("Bullied comments")
      .when("Bullied", { is: "Yes", then: Joi.required() }),
    AcceptedByPeers: Joi.string()
      .label("Accepted by peer group")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    AcceptedByPeersDetails: Joi.string()
      .label("Peer group comments")
      .when("AcceptedByPeers", { is: "No", then: Joi.required() }),
    NegativeAssociations: Joi.string()
      .label("Negative peer group associations")
      .when("RelationshipsNA", { is: false, then: Joi.required() }),
    NegativeAssociationsDetails: Joi.string()
      .label("Negative associations comments")
      .when("NegativeAssociations", { is: "Yes", then: Joi.required() }),
    LegalNA: Joi.boolean(),
    LegalInvolvement: Joi.string()
      .label("Legal involvement")
      .when("LegalNA", { is: false, then: Joi.required() }),
    OnProbation: Joi.string()
      .label("On probation or parole")
      .when("LegalInvolvement", { is: "Yes", then: Joi.required() }),
    CPSInvolvement: Joi.string()
      .label("CPS Involvement")
      .when("LegalNA", { is: false, then: Joi.required() }),
    CPSInvolvementDetails: Joi.string()
      .label("CPS Involvmenet details")
      .when("CPSInvolvement", { is: "Current", then: Joi.required() })
      .when("CPSInvolvement", { is: "Historical", then: Joi.required() }),
    PCP: Joi.string().label("Primary Care Physician").required(),
    PCPPhone: Joi.string().label("Primary Care Physician Phone").required(),
    LastMedicalExamDate: Joi.string()
      .label("Date of last medical exam")
      .required(),
    LastDentalExamDate: Joi.string()
      .label("Date of last dental exam")
      .required(),
    Allergies: Joi.boolean(),
    AllergiesDetails: Joi.string()
      .label("Allergies")
      .when("Allergies", { is: true, then: Joi.required() }),
    MedicalConditions: Joi.boolean(),
    MedicalConditionsDetails: Joi.string()
      .label("Medical Conditions/Concerns")
      .when("MedicalConditions", { is: true, then: Joi.required() }),
    NutritionalConcerns: Joi.boolean(),
    NutritionalConcernsDetails: Joi.string()
      .label("Nutritional Concerns")
      .when("NutritionalConcerns", { is: true, then: Joi.required() }),
    DentalConcerns: Joi.boolean(),
    DentalConcernsDetails: Joi.string()
      .label("Dental Concerns")
      .when("DentalConcerns", { is: true, then: Joi.required() }),
    Concussions: Joi.boolean(),
    ConcussionsDetails: Joi.string()
      .label("Concussions or Head Injuries")
      .when("Concussions", { is: true, then: Joi.required() }),
    Undiagnosed: Joi.string().label("Undiagnosed medical illness").required(),
    UndiagnosedComments: Joi.string()
      .label("Undiagnosed medical illness comments")
      .when("Undiagnosed", { is: "Yes", then: Joi.required() }),
    MedicalComments: Joi.string().label("Medical comments").allow(null, ""),
    AdvanceDirectives: Joi.string().label("Advance directives").required(),
    NoMedications: Joi.boolean(),
    CurrentMedicationDetails: Joi.string()
      .label("Current Medications")
      .when("NoMedications", { is: false, then: Joi.required() }),
    MedicationCompliance: Joi.string()
      .label("Compliance with medication")
      .when("NoMedications", { is: false, then: Joi.required() }),
    SideEffects: Joi.string()
      .label("Side effects")
      .when("NoMedications", { is: false, then: Joi.required() }),
    SideEffectsDetails: Joi.string()
      .label("Side effects details")
      .when("SideEffects", { is: "Yes", then: Joi.required() }),
    PsychotropicMeds: Joi.string()
      .label("Past Psychotropic Medications")
      .when("NoMedications", { is: false, then: Joi.required() }),
    PsychotropicMedsDetails: Joi.string()
      .label("Past Psychotropic Medications list")
      .when("PsychotropicMeds", { is: "Yes", then: Joi.required() }),
    SexualHistoryNA: Joi.boolean(),
    SexualOrientation: Joi.string()
      .label("Sexual orientation")
      .when("SexualHistoryNA", { is: false, then: Joi.required() }),
    SexualOrientationDetails: Joi.string()
      .label("Sexual Orientation specifics")
      .when("SexualOrientation", {
        is: "Orientation not listed",
        then: Joi.required(),
      }),
    SexuallyActive: Joi.string()
      .label("Sexually active")
      .when("SexualHistoryNA", { is: false, then: Joi.required() }),
    CaregiverAware: Joi.when("SexualHistoryNA", {
      is: false,
      then: Joi.when("SexuallyActive", {
        is: "Yes",
        then: Joi.string()
          .required()
          .label("Caregiver aware of sexual history"),
      }),
    }),
    CaregiverAwareComments: Joi.when("SexualHistoryNA", {
      is: false,
      then: Joi.when("SexuallyActive", {
        is: "Yes",
        then: Joi.when("CaregiverAware", {
          is: "Yes",
          then: Joi.string().required().label("Caregiver comments"),
        }),
      }),
    }),
    UseProtection: Joi.when("SexualHistoryNA", {
      is: false,
      then: Joi.when("SexuallyActive", {
        is: "Yes",
        then: Joi.string().required().label("Use of protection"),
      }),
    }),
    UseProtectionComments: Joi.when("SexualHistoryNA", {
      is: false,
      then: Joi.when("SexuallyActive", {
        is: "Yes",
        then: Joi.when("UseProtection", {
          is: "Yes",
          then: Joi.string().label("Protection comments"),
        }),
      }),
    }),
    AwareOfRisks: Joi.when("SexualHistoryNA", {
      is: false,
      then: Joi.when("SexuallyActive", {
        is: "Yes",
        then: Joi.string().required().label("Awareness of sexual risks"),
      }),
    }),
    AwareOfRisksComments: Joi.when("SexualHistoryNA", {
      is: false,
      then: Joi.when("SexuallyActive", {
        is: "Yes",
        then: Joi.when("AwareOfRisks", {
          is: "Yes",
          then: Joi.string().required().label("Sexual risks comments"),
        }),
      }),
    }),
    Pregnancy: Joi.when("SexAssignedAtBirth", {
      is: "Female",
      then: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexuallyActive", {
          is: "Yes",
          then: Joi.string().required().label("Pregnancy"),
        }),
      }),
    }),
    PregnancyComments: Joi.when("SexAssignedAtBirth", {
      is: "Female",
      then: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexuallyActive", {
          is: "Yes",
          then: Joi.when("Pregnancy", {
            is: "Current",
            then: Joi.string().required().label("Pregnancy comments"),
          }),
        }),
      }),
    }),
    PregnancyDesire: Joi.when("SexAssignedAtBirth", {
      is: "Female",
      then: Joi.when("SexualHistoryNA", {
        is: false,
        then: Joi.when("SexuallyActive", {
          is: "Yes",
          then: Joi.string()
            .required()
            .error((errors) => {
              errors.forEach((error) => {
                switch (error.type) {
                  default:
                    error.message = "Please select a response";
                    break;
                }
              });
              return errors;
            }),
        }),
      }),
    }),
    Children: Joi.when("SexualHistoryNA", {
      is: false,
      then: Joi.when("SexuallyActive", {
        is: "Yes",
        then: Joi.string().required().label("Children"),
      }),
    }),
    ChildrenComments: Joi.when("SexualHistoryNA", {
      is: false,
      then: Joi.when("SexuallyActive", {
        is: "Yes",
        then: Joi.when("Children", {
          is: "Yes",
          then: Joi.string().required().label("Children comments"),
        }),
      }),
    }),
    SexualAbuseVictim: Joi.when("SexualHistoryNA", {
      is: false,
      then: Joi.string().required().label("Victim of sexual abuse"),
    }),
    SexualAbuseVictimComments: Joi.when("SexualHistoryNA", {
      is: false,
      then: Joi.when("SexualAbuseVictim", {
        is: "Yes",
        then: Joi.string().required().label("Sexual abuse comments"),
      }),
    }),
    SexuallyActingOut: Joi.string()
      .label("Sexually acting out/reactive behavior")
      .when("SexualHistoryNA", { is: false, then: Joi.required() }),
    SexuallyAbusive: Joi.string()
      .label("Sexually abusive")
      .when("SexualHistoryNA", { is: false, then: Joi.required() }),
    SexuallyAbusiveComments: Joi.when("SexualHistoryNA", {
      is: false,
      then: Joi.when("SexuallyActingOut", {
        is: "Yes",
        then: Joi.string().required(),
      })
        .when("SexuallyAbusive", { is: "Yes", then: Joi.string().required() })
        .label("Sexually abusive comments"),
    }),
    MentalHealthNA: Joi.boolean(),
    PastMentalHealthTreatment: Joi.string()
      .label("Past mental health counseling/treatment")
      .allow(""),
    PastMentalHealthTreatmentComments: Joi.string()
      .label("Past mental health counseling/treatment comments")
      .when("PastMentalHealthTreatment", { is: "Yes", then: Joi.required() }),
    PastResidentialFacilityPlacement: Joi.string()
      .label("Past placement in a group home/residential treatment facility")
      .allow(""),
    PastResidentialFacilityPlacementComments: Joi.string()
      .label("Past placement comments")
      .when("PastResidentialFacilityPlacement", {
        is: "Yes",
        then: Joi.required(),
      }),
    PastPsychiatricHospitalPlacement: Joi.string()
      .label("Past placement in a psychiatric hospital/unit")
      .allow(""),
    PastPsychiatricHospitalPlacementComments: Joi.string()
      .label("Past placement comments")
      .when("PastPsychiatricHospitalPlacement", {
        is: "Yes",
        then: Joi.required(),
      }),
    InvoluntaryTreatment: Joi.string()
      .label("History of involuntary/court-ordered treatment")
      .allow(""),
    InvoluntaryTreatmentComments: Joi.string()
      .label("Involuntary treatment comments")
      .when("InvoluntaryTreatment", { is: "Yes", then: Joi.required() }),
    MentalHealthDiagnosis: Joi.string().allow(""),
    SubstanceUseNA: Joi.boolean(),
    SubstanceUse: Joi.string()
      .label("Current or past use of Alcohol/Drugs")
      .when("SubstanceUseNA", { is: false, then: Joi.required() }),
    TobaccoUse: Joi.label("Tobacco related products").when("SubstanceUseNA", {
      is: false,
      then: Joi.string().when("SubstanceUse", {
        is: "Yes",
        then: Joi.required(),
      }),
    }),
    AlcoholUse: Joi.label("Alcohol").when("SubstanceUseNA", {
      is: false,
      then: Joi.string().when("SubstanceUse", {
        is: "Yes",
        then: Joi.required(),
      }),
    }),
    IllegalDrugUse: Joi.label("Illegal drugs").when("SubstanceUseNA", {
      is: false,
      then: Joi.string().when("SubstanceUse", {
        is: "Yes",
        then: Joi.required(),
      }),
    }),
    PrescriptionDrugUse: Joi.label("Prescription drugs").when(
      "SubstanceUseNA",
      {
        is: false,
        then: Joi.string().when("SubstanceUse", {
          is: "Yes",
          then: Joi.required(),
        }),
      }
    ),
    SyntheticDrugUse: Joi.label("Synthetic drugs/substances").when(
      "SubstanceUseNA",
      {
        is: false,
        then: Joi.string().when("SubstanceUse", {
          is: "Yes",
          then: Joi.required(),
        }),
      }
    ),
    SubstanceUseTreatmentHistory: Joi.label(
      "Medical treatment/hospitalization due to use"
    ).when("SubstanceUseNA", {
      is: false,
      then: Joi.string().when("SubstanceUse", {
        is: "Yes",
        then: Joi.required(),
      }),
    }),
    SubstanceUseWithdrawal: Joi.label("Withdrawal").when("SubstanceUseNA", {
      is: false,
      then: Joi.string().when("SubstanceUse", {
        is: "Yes",
        then: Joi.required(),
      }),
    }),
    DetoxSymptoms: Joi.label("Presenting detox issues").when("SubstanceUseNA", {
      is: false,
      then: Joi.string().when("SubstanceUse", {
        is: "Yes",
        then: Joi.required(),
      }),
    }),
    OverdoseHistory: Joi.label("Overdose history").when("SubstanceUseNA", {
      is: false,
      then: Joi.string().when("SubstanceUse", {
        is: "Yes",
        then: Joi.required(),
      }),
    }),
    SubstanceUseLegalInvolvement: Joi.label(
      "Legal charges/involvement due to use"
    ).when("SubstanceUseNA", {
      is: false,
      then: Joi.string().when("SubstanceUse", {
        is: "Yes",
        then: Joi.required(),
      }),
    }),
    SubstanceUseProblems: Joi.label(
      "Use has caused problems in different areas of your life"
    ).when("SubstanceUseNA", {
      is: false,
      then: Joi.string().when("SubstanceUse", {
        is: "Yes",
        then: Joi.required(),
      }),
    }),
    SubstanceUseHistoryComments: Joi.label(
      "Substance use history comments"
    ).when("SubstanceUseNA", {
      is: false,
      then: Joi.string().when("SubstanceUse", {
        is: "Yes",
        then: Joi.required(),
      }),
    }),
    SubstanceUseTreatment: Joi.label("Alcohol/drug related treatment").when(
      "SubstanceUseNA",
      {
        is: false,
        then: Joi.string().when("SubstanceUse", {
          is: "Yes",
          then: Joi.required(),
        }),
      }
    ),
    SubstanceUseTreatmentComments: Joi.string()
      .label("Alcohol/drug related treatment comments")
      .when("SubstanceUseTreatment", { is: "Yes", then: Joi.required() }),
    AppropriateAppearance: Joi.boolean(),
    Neat: Joi.boolean(),
    Disheveled: Joi.boolean(),
    BizarreAppearance: Joi.boolean(),
    OtherAppearance: Joi.boolean(),
    OtherAppearanceDetails: Joi.string()
      .label("Other Appearance details")
      .when("OtherAppearance", { is: true, then: Joi.required() }),
    Cooperative: Joi.boolean(),
    Guarded: Joi.boolean(),
    Hyperactive: Joi.boolean(),
    Agitated: Joi.boolean(),
    Paranoid: Joi.boolean(),
    Tics: Joi.boolean(),
    Impulsive: Joi.boolean(),
    Aggressive: Joi.boolean(),
    Withdrawn: Joi.boolean(),
    BizarreBehavior: Joi.boolean(),
    Rigidity: Joi.boolean(),
    OtherBehavior: Joi.boolean(),
    OtherBehaviorDetails: Joi.string()
      .label("Other Behavior details")
      .when("OtherBehavior", { is: true, then: Joi.required() }),
    Normal: Joi.boolean(),
    Slurred: Joi.boolean(),
    Pressured: Joi.boolean(),
    Tangential: Joi.boolean(),
    Incoherent: Joi.boolean(),
    Stutters: Joi.boolean(),
    OtherSpeech: Joi.boolean(),
    OtherSpeechDetails: Joi.string()
      .label("Other Speech details")
      .when("OtherSpeech", { is: true, then: Joi.required() }),
    Euthymic: Joi.boolean(),
    Anxious: Joi.boolean(),
    Angry: Joi.boolean(),
    Depressed: Joi.boolean(),
    Euphoric: Joi.boolean(),
    Irritable: Joi.boolean(),
    Fearful: Joi.boolean(),
    OtherMood: Joi.boolean(),
    OtherMoodDetails: Joi.string()
      .label("Other Mood details")
      .when("OtherMood", { is: true, then: Joi.required() }),
    FullRange: Joi.boolean(),
    Restricted: Joi.boolean(),
    Blunted: Joi.boolean(),
    Flat: Joi.boolean(),
    Inappropriate: Joi.boolean(),
    OtherAffect: Joi.boolean(),
    OtherAffectDetails: Joi.string()
      .label("Other Affect details")
      .when("OtherAffect", { is: true, then: Joi.required() }),
    Logical: Joi.boolean(),
    Preoccupations: Joi.boolean(),
    Delusions: Joi.boolean(),
    Hallucinations: Joi.boolean(),
    Racing: Joi.boolean(),
    Disorganized: Joi.boolean(),
    Concrete: Joi.boolean(),
    SuicidalIdeation: Joi.boolean(),
    HomicidalIdeation: Joi.boolean(),
    OtherPerception: Joi.boolean(),
    OtherPerceptionDetails: Joi.string()
      .label("Other Thought Process/Perception details")
      .when("OtherPerception", { is: true, then: Joi.required() }),
    NoImpairment: Joi.boolean(),
    ShortAttentionSpan: Joi.boolean(),
    DifficultyConcentrating: Joi.boolean(),
    Distractibility: Joi.boolean(),
    MemoryImpairment: Joi.boolean(),
    LowIntelligence: Joi.boolean(),
    OtherCognition: Joi.boolean(),
    OtherCognitionDetails: Joi.string()
      .label("Other Cognition/Intellectual Functioning details")
      .when("OtherCognition", { is: true, then: Joi.required() }),
    AppropriateInsight: Joi.boolean(),
    Fair: Joi.boolean(),
    Impaired: Joi.boolean(),
    OtherInsight: Joi.boolean(),
    OtherInsightDetails: Joi.string()
      .label("Other Insight/Judgment details")
      .when("OtherInsight", { is: true, then: Joi.required() }),
    MentalStatusComments: Joi.string()
      .label("Mental Status comments")
      .required(),
    LethalityNA: Joi.boolean(),
    SelfAbusiveBehavior: Joi.string()
      .label("Self-abusive behavior")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    SuicidalThreats: Joi.string()
      .label("Suicidal threats")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    SuicideAttempt: Joi.string()
      .label("Suicide attempt")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    CaregiverConcernsOfSelfHarm: Joi.string()
      .label("Caregiver concerns of self-harm")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    OtherConcernsOfSelfHarm: Joi.string()
      .label("Other concerns of self-harm")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    CurrentSelfHarmRisk: Joi.string()
      .label("Current Risk of Harm to Self")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    SelfHarmComments: Joi.string()
      .label("Self-harm comments")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ThreatsToHarmOthers: Joi.string()
      .label("Threats to harm others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ThoughtsOfHarm: Joi.string()
      .label("Thoughts of harming others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ActsOfHarm: Joi.string()
      .label("Acts of harming others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ActsOfHarmAnimals: Joi.string()
      .label("Acts of harming animals")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    ActsInvolvingWeapons: Joi.string()
      .label("Acts involving weapons")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    CaregiverConcernOfOtherHarm: Joi.string()
      .label("Caregiver concerns of harming others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    OtherConcernsOfOtherHarm: Joi.string()
      .label("Other concerns of harming others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    CurrentOtherHarmRisk: Joi.string()
      .label("Current Risk of Harm to Others")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    OtherHarmComments: Joi.string()
      .label("Threat to others comments")
      .when("LethalityNA", { is: false, then: Joi.required() }),
    TraumaNA: Joi.boolean(),
    TraumaHistory: Joi.string()
      .label("Trauma History")
      .when("TraumaNA", { is: false, then: Joi.required() }),
    SocialSupports: Joi.boolean(),
    SenseOfMastery: Joi.boolean(),
    CaregiverStability: Joi.boolean(),
    StrongSpiritualBeliefs: Joi.boolean(),
    InterpersonalSkills: Joi.boolean(),
    PositiveOutlook: Joi.boolean(),
    PlacementStability: Joi.boolean(),
    Pets: Joi.boolean(),
    ValidatingExperiences: Joi.boolean(),
    Resources: Joi.boolean(),
    TiesToExtendedFamily: Joi.boolean(),
    Adaptability: Joi.boolean(),
    SecureAttachments: Joi.boolean(),
    StrongCulturalIdentity: Joi.boolean(),
    NoTraumaProtectiveFactors: Joi.boolean(),
    CopingStrategies: Joi.string()
      .label("Coping strategies")
      .when("TraumaNA", { is: false, then: Joi.required() }),
    TraumaSymptoms: Joi.boolean(),
    TraumaticExposure: Joi.boolean(),
    AvoidantTrauma: Joi.boolean(),
    HypervigilanceTrauma: Joi.boolean(),
    IntrusiveDreams: Joi.boolean(),
    NegativeThoughts: Joi.boolean(),
    CocentrationProblems: Joi.boolean(),
    RecklessBehaviorTrauma: Joi.boolean(),
    SleepDisturbancesTrauma: Joi.boolean(),
    OtherTrauma: Joi.boolean(),
    OtherTraumaDetails: Joi.string()
      .label("Other Trauma Details")
      .when("OtherTrauma", { is: true, then: Joi.required() }),
    TraumaSymptomsFrequency: Joi.string()
      .label("Trauma Symptoms Frequency")
      .when("TraumaSymptoms", { is: true, then: Joi.required() }),
    TraumaSymptomsIntensity: Joi.string()
      .label("Trauma Symptoms Intensity")
      .when("TraumaSymptoms", { is: true, then: Joi.required() }),
    TraumaSymptomsDuration: Joi.string()
      .label("Trauma Symptoms Duration")
      .when("TraumaSymptoms", { is: true, then: Joi.required() }),
    TraumaSymptomsOnset: Joi.string()
      .label("Trauma Symptoms Onset")
      .when("TraumaSymptoms", { is: true, then: Joi.required() }),
    AnxietyDisorder: Joi.boolean(),
    AnxietyDisorderExcessWorry: Joi.boolean(),
    AnxietyDisorderEasilyFatigued: Joi.boolean(),
    MuscleTension: Joi.boolean(),
    Overworried: Joi.boolean(),
    AnxietyDisorderDifficultyConcentrating: Joi.boolean(),
    SleepDisturbancesAnxiety: Joi.boolean(),
    RestlessAnxiety: Joi.boolean(),
    Irritability: Joi.boolean(),
    OtherAnxiety: Joi.boolean(),
    OtherAnxietyDetails: Joi.string()
      .label("Other Anxiety Details")
      .when("OtherAnxiety", { is: true, then: Joi.required() }),
    AnxietyDisorderFrequency: Joi.string()
      .label("Anxiety Frequency")
      .when("AnxietyDisorder", { is: true, then: Joi.required() }),
    AnxietyDisorderIntensity: Joi.string()
      .label("Anxiety Intensity")
      .when("AnxietyDisorder", { is: true, then: Joi.required() }),
    AnxietyDisorderDuration: Joi.string()
      .label("Anxiety Duration")
      .when("AnxietyDisorder", { is: true, then: Joi.required() }),
    DepressionSymptoms: Joi.boolean(),
    DepressedMood: Joi.boolean(),
    SleepChanges: Joi.boolean(),
    Guilt: Joi.boolean(),
    DiminishedInterest: Joi.boolean(),
    PurposelessMovement: Joi.boolean(),
    DifficultyConcentratingDepression: Joi.boolean(),
    WeightChanges: Joi.boolean(),
    FatigueDepression: Joi.boolean(),
    ThoughtsOfDeath: Joi.boolean(),
    OtherDepression: Joi.boolean(),
    OtherDepressionDetails: Joi.string()
      .label("Other Depression Details")
      .when("OtherDepression", { is: true, then: Joi.required() }),
    DepressionFrequency: Joi.string()
      .label("Depression Frequency")
      .when("DepressionSymptoms", { is: true, then: Joi.required() }),
    DepressionIntensity: Joi.string()
      .label("Depression Intensity")
      .when("DepressionSymptoms", { is: true, then: Joi.required() }),
    DepressionDuration: Joi.string()
      .label("Depression Duration")
      .when("DepressionSymptoms", { is: true, then: Joi.required() }),
    AttentionHyperactivity: Joi.boolean(),
    AttentionHyperactivityEasilyDistracted: Joi.boolean(),
    DifficultyFollowThrough: Joi.boolean(),
    Forgetful: Joi.boolean(),
    DifficultyListening: Joi.boolean(),
    DisorganizedAttention: Joi.boolean(),
    Fidgety: Joi.boolean(),
    LackOfDetails: Joi.boolean(),
    LosesThings: Joi.boolean(),
    InterruptsOthers: Joi.boolean(),
    UnableToSitStill: Joi.boolean(),
    ExcessiveTalking: Joi.boolean(),
    DifficultyWaiting: Joi.boolean(),
    OtherAttention: Joi.boolean(),
    OtherAttentionDetails: Joi.string()
      .label("Other Attention Details")
      .when("OtherAttention", { is: true, then: Joi.required() }),
    AttentionHyperactivityFrequency: Joi.string()
      .label("Attention Frequency")
      .when("AttentionHyperactivity", { is: true, then: Joi.required() }),
    AttentionHyperactivityIntensity: Joi.string()
      .label("Attention Intensity")
      .when("AttentionHyperactivity", { is: true, then: Joi.required() }),
    AttentionHyperactivityDuration: Joi.string()
      .label("Attention Duration")
      .when("AttentionHyperactivity", { is: true, then: Joi.required() }),
    SU: Joi.boolean(),
    PatternOfSubstanceUse: Joi.boolean(),
    DesiresCutDownUse: Joi.boolean(),
    TimeSpentObtaining: Joi.boolean(),
    Cravings: Joi.boolean(),
    FailureOfResponsibilities: Joi.boolean(),
    NegativeImpact: Joi.boolean(),
    AbandonsActivities: Joi.boolean(),
    Tolerance: Joi.boolean(),
    SUWithdrawal: Joi.boolean(),
    SUOther: Joi.boolean(),
    SUOtherDetails: Joi.string()
      .label("Other Substance Use Details")
      .when("SUOther", { is: true, then: Joi.required() }),
    SubstanceUseFrequency: Joi.string()
      .label("Substance Use Frequency")
      .when("SU", { is: true, then: Joi.required() }),
    SubstanceUseIntensity: Joi.string()
      .label("Substance Use Intensity")
      .when("SU", { is: true, then: Joi.required() }),
    SubstanceUseDuration: Joi.string()
      .label("Substance Use Duration")
      .when("SU", { is: true, then: Joi.required() }),
    DMDD: Joi.boolean(),
    Temper: Joi.boolean(),
    OutsideOutbursts: Joi.boolean(),
    FrequentOutbursts: Joi.boolean(),
    DMDDIrritable: Joi.boolean(),
    OutburstsAroundOthers: Joi.boolean(),
    DMDDOther: Joi.boolean(),
    DMDDOtherDetails: Joi.string()
      .label("Other Disruptive Mood Dysregulation Disorder Details")
      .when("DMDDOther", { is: true, then: Joi.required() }),
    DMDDFrequency: Joi.string()
      .label("Disruptive Mood Dysregulation Disorder Frequency")
      .when("DMDD", { is: true, then: Joi.required() }),
    DMDDIntensity: Joi.string()
      .label("Disruptive Mood Dysregulation Disorder Intensity")
      .when("DMDD", { is: true, then: Joi.required() }),
    DMDDDuration: Joi.string()
      .label("Disruptive Mood Dysregulation Disorder Duration")
      .when("DMDD", { is: true, then: Joi.required() }),
    ConductDisorder: Joi.boolean(),
    Aggression: Joi.boolean(),
    DestructionOfProperty: Joi.boolean(),
    Theft: Joi.boolean(),
    SeriousViolations: Joi.boolean(),
    OtherConductDisorder: Joi.boolean(),
    OtherConductDisorderDetails: Joi.string()
      .label("Other Conduct Disorder Details")
      .when("OtherConductDisorder", { is: true, then: Joi.required() }),
    ConductDisorderFrequency: Joi.string()
      .label("Conduct Disorder Frequency")
      .when("ConductDisorder", { is: true, then: Joi.required() }),
    ConductDisorderIntensity: Joi.string()
      .label("Conduct Disorder Intensity")
      .when("ConductDisorder", { is: true, then: Joi.required() }),
    ConductDisorderDuration: Joi.string()
      .label("Conduct Disorder Duration")
      .when("ConductDisorder", { is: true, then: Joi.required() }),
    ODD: Joi.boolean(),
    IrritableODD: Joi.boolean(),
    Argumentative: Joi.boolean(),
    Vindictive: Joi.boolean(),
    OtherODD: Joi.boolean(),
    OtherODDDetails: Joi.string()
      .label("Other Oppositional Defiance Disorder Details")
      .when("OtherODD", { is: true, then: Joi.required() }),
    ODDFrequency: Joi.string()
      .label("Oppositional Defiance Disorder Frequency")
      .when("ODD", { is: true, then: Joi.required() }),
    ODDIntensity: Joi.string()
      .label("Oppositional Defiance Disorder Intensity")
      .when("ODD", { is: true, then: Joi.required() }),
    ODDDuration: Joi.string()
      .label("Oppositional Defiance Disorder Duration")
      .when("ODD", { is: true, then: Joi.required() }),
    OCD: Joi.boolean(),
    OCDPresence: Joi.boolean(),
    Obsessions: Joi.boolean(),
    TimeConsuming: Joi.boolean(),
    Compulsions: Joi.boolean(),
    ReduceAnxiety: Joi.boolean(),
    SuppressUrges: Joi.boolean(),
    OCDOther: Joi.boolean(),
    OCDOtherDetails: Joi.string()
      .label("Other Obsessive-Compulsive Disorder Details")
      .when("OCDOther", { is: true, then: Joi.required() }),
    OCDFrequency: Joi.string()
      .label("Obsessive-Compulsive Disorder Frequency")
      .when("OCD", { is: true, then: Joi.required() }),
    OCDIntensity: Joi.string()
      .label("Obsessive-Compulsive Disorder Intensity")
      .when("OCD", { is: true, then: Joi.required() }),
    OCDDuration: Joi.string()
      .label("Obsessive-Compulsive Disorder Duration")
      .when("OCD", { is: true, then: Joi.required() }),
    PanicDisorder: Joi.boolean(),
    PoundingHeart: Joi.boolean(),
    PanicDisorderSweating: Joi.boolean(),
    Trembling: Joi.boolean(),
    ShortnessOfBreath: Joi.boolean(),
    Choking: Joi.boolean(),
    ChestPain: Joi.boolean(),
    PanicDisorderNausea: Joi.boolean(),
    Dizzy: Joi.boolean(),
    Chills: Joi.boolean(),
    Derealization: Joi.boolean(),
    FearOfCrazy: Joi.boolean(),
    FearOfDying: Joi.boolean(),
    PanicDisorderOther: Joi.boolean(),
    PanicDisorderOtherDetails: Joi.string()
      .label("Other Panic Disorder Details")
      .when("PanicDisorderOther", { is: true, then: Joi.required() }),
    PanicDisorderFrequency: Joi.string()
      .label("Panic Disorder Frequency")
      .when("PanicDisorder", { is: true, then: Joi.required() }),
    PanicDisorderIntensity: Joi.string()
      .label("Panic Disorder Intensity")
      .when("PanicDisorder", { is: true, then: Joi.required() }),
    PanicDisorderDuration: Joi.string()
      .label("Panic Disorder Duration")
      .when("PanicDisorder", { is: true, then: Joi.required() }),
    Phobias: Joi.boolean(),
    PhobiasSpecificFear: Joi.boolean(),
    ImmediateFear: Joi.boolean(),
    PhobiasAvoidance: Joi.boolean(),
    FearExaggerated: Joi.boolean(),
    PhobiasOther: Joi.boolean(),
    PhobiasOtherDetails: Joi.string()
      .label("Other Phobia Details")
      .when("PhobiasOther", { is: true, then: Joi.required() }),
    PhobiasFrequency: Joi.string()
      .label("Phobia Frequency")
      .when("Phobias", { is: true, then: Joi.required() }),
    PhobiasIntensity: Joi.string()
      .label("Phobia Intensity")
      .when("Phobias", { is: true, then: Joi.required() }),
    PhobiasDuration: Joi.string()
      .label("Phobia Duration")
      .when("Phobias", { is: true, then: Joi.required() }),
    DI: Joi.boolean(),
    DILowIQ: Joi.boolean(),
    DISensoryImpairments: Joi.boolean(),
    DISpeechDelays: Joi.boolean(),
    DIMotorCoordinationDelays: Joi.boolean(),
    DILearningDisorder: Joi.boolean(),
    DISpatialDelays: Joi.boolean(),
    DevelopmentalImpairmentsOther: Joi.boolean(),
    DevelopmentalImpairmentsOtherDetails: Joi.string()
      .label("Other Developmental Impairments Details")
      .when("DevelopmentalImpairmentsOther", {
        is: true,
        then: Joi.required(),
      }),
    DevelopmentalImpairmentsDetails: Joi.string()
      .label("Developmental Impairments Description")
      .when("DILowIQ", { is: true, then: Joi.required() })
      .when("DISensoryImpairments", { is: true, then: Joi.required() })
      .when("DISpeechDelays", { is: true, then: Joi.required() })
      .when("DIMotorCoordinationDelays", { is: true, then: Joi.required() })
      .when("DILearningDisorder", { is: true, then: Joi.required() })
      .when("DISpatialDelays", { is: true, then: Joi.required() }),
    OtherSymptoms: Joi.boolean(),
    OtherSymptomsDetails: Joi.string()
      .label("Other Symptom Details")
      .when("OtherSymptoms", { is: true, then: Joi.required() }),
    OtherSymptomsFrequency: Joi.string()
      .label("Other Symptoms Frequency")
      .when("OtherSymptoms", { is: true, then: Joi.required() }),
    OtherSymptomsIntensity: Joi.string()
      .label("Other Symptoms Intensity")
      .when("OtherSymptoms", { is: true, then: Joi.required() }),
    OtherSymptomsDuration: Joi.string()
      .label("Other Symptoms Duration")
      .when("OtherSymptoms", { is: true, then: Joi.required() }),
    ClinicalNarrativeSummary: Joi.string()
      .label("Clinical Narrative Summary")
      .required(),
    ClinicalNarrativeSummaryComments: Joi.string()
      .label("Clinical Narrative Summary")
      .allow(""),
    TraditionalFosterCare: Joi.string()
      .label("Traditional Foster Care")
      .required(),
    DiagnosisDetails: Joi.string()
      .label("Diagnosis details")
      .when("TraditionalFosterCare", { is: "No", then: Joi.required() }),
    TreatmentRecommendations: Joi.string()
      .label("Treatment Recommendations")
      .required(),
    DiagnosisEducation: Joi.string().label("Diagnosis education").required(),
    RecommendationEducation: Joi.string()
      .label("Recommendation education")
      .required(),
    ClientAgrees: Joi.string().label("Client in agreement").required(),
    FamilyAgress: Joi.string().label("Family in agreement").required(),
    Partnership: Joi.string()
      .label("Partnership with other systems")
      .required(),
    NoPartnershipReason: Joi.string()
      .label("Reason for no partnership")
      .when("Partnership", { is: "No", then: Joi.required() }),
  };
}
